module.exports = __webpack_public_path__ + "static/media/Navigation_Darker.b02f09b3.png";